import { deleteNamespace } from "../../../api/deleteNamespace";
import { getAPIErrorMessage } from "../../../helpers/helpers";
import {
  NotificationType,
} from "../../../store/storeNotifications";
import { Namespace } from "../../../types/namespace";
import type { Space } from "../../../util/Types/Sidebar";

export interface VectorMemoryDeletionDeps {
  spaces: Space[];
  updateSpace: (spaceId: string, updater: (space: Space) => Space) => void;
  refreshSidebar: () => void;
  setNotification: (n: { type: NotificationType; message: string }) => void;
}

export async function executeVectorMemoryDeletion(
  ns: Namespace,
  deps: VectorMemoryDeletionDeps,
): Promise<void> {
  const spaceId = deps.spaces.find((s) =>
    s.namespaces?.some((n) => n.id === ns.id),
  )?.id;
  try {
    if (spaceId) {
      deps.updateSpace(spaceId, (space) => ({
        ...space,
        namespaces: space.namespaces?.filter((n) => n.id !== ns.id) || [],
      }));
    }
    if (!spaceId) deps.refreshSidebar();
    await deleteNamespace({
      body: {
        embeddingModelName: ns.embeddingModelName || "voyage-3-large",
      },
      params: { id: ns.id, nameSpace: ns.name, spaceId },
    });
    deps.setNotification({
      type: NotificationType.Success,
      message: "Vector memory deleted successfully",
    });
  } catch (error) {
    deps.refreshSidebar();
    deps.setNotification({
      type: NotificationType.Error,
      message: getAPIErrorMessage(error as Error),
    });
  }
}
